import { observer } from 'src/utils/mobx-react';
import { RegistryFieldsType, RegistryWidgetsType, RJSFValidationError, UiSchema } from '@rjsf/utils';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import {
    AddButton,
    CustomArrayFieldTemplate,
    CustomErrorList,
    CustomFieldTemplate,
    CustomObjectFieldTemplate,
    DescriptionFieldTemplate,
    MoveDownButton,
    MoveUpButton,
    RemoveButton,
    SubmitButton,
    TitleFieldTemplate,
} from 'src/domains/layouts/webview/ConfigurationManager/components/customTemplates/customTemplates';
import React from 'react';
import {
    CustomCheckbox,
    CustomDescriptionField,
    CustomString,
    CustomTitleField,
} from 'src/domains/layouts/webview/ConfigurationManager/components/customFormElements/customFormElements';
import { ServiceSettingsFormState } from 'src/domains/layouts/webview/ConfigurationManager/serviceSettingsForm/serviceSettingsForm.state';
import { useCommon } from 'src/AppState/Common';
import { FormContainer } from 'src/domains/layouts/webview/ConfigurationManager/serviceSettingsForm/serviceSettingsForm.style';
import { resolveObjectPath, transformPath } from 'src/domains/layouts/webview/ConfigurationManager/utils';

type CustomValidatorsOverridesType = (
    schema: Record<string, unknown>,
    idsValueToSendAsNull: Array<string>
) => (errors: Array<RJSFValidationError>) => Array<RJSFValidationError>;
const customValidatorsOverrides: CustomValidatorsOverridesType = (
    schema: Record<string, unknown>,
    idsValueToSendAsNull: Array<string>
) => {
    return (errors: Array<RJSFValidationError>): Array<RJSFValidationError> => {
        const pathsOfNullValues = idsValueToSendAsNull.map((idSchema) => transformPath(idSchema));
        return errors.filter((error) => {
            console.log('error ', error);
            const pathOfValue = error.property?.replaceAll('.', '/');
            const shouldNoValidate = pathsOfNullValues.includes(pathOfValue ?? '');
            const schemaPath = error.schemaPath;
            if (schemaPath === undefined) {
                return true;
            }
            const fieldType = resolveObjectPath(schema, schemaPath);
            if (fieldType === 'x-secret' || shouldNoValidate) {
                return false; // Skip RJSF validation
            }
            return true;
        });
    };
};

const customWidgets: RegistryWidgetsType = { CheckboxWidget: CustomCheckbox };

type FromWrapperPropsType = {
    currentServiceId: string | null;
};

export const ServiceSettingsFormWrapper = observer('FormWrapper', (props: FromWrapperPropsType): JSX.Element | null => {
    const common = useCommon();
    if (props.currentServiceId === null) {
        return null;
    }
    const state = ServiceSettingsFormState.get(common, props.currentServiceId);

    const data = state.getReady();
    if (data === null) {
        return <div>Loading...</div>;
    }

    const customFields: (serviceId: string) => RegistryFieldsType = (serviceId) => ({
        StringField: (props): JSX.Element => {
            return (
                <CustomString
                    {...props}
                    currentServiceId={serviceId}
                />
            );
        },
        TitleField: CustomTitleField,
        DescriptionField: CustomDescriptionField,
    });

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const schema = data.schema as UiSchema;

    console.log('schema ', schema);

    return (
        <FormContainer>
            <Form
                schema={schema}
                formData={data.value}
                validator={validator}
                transformErrors={customValidatorsOverrides(schema.definitions, state.idsValueToSendAsNull)}
                fields={customFields(props.currentServiceId)}
                widgets={customWidgets}
                onSubmit={state.onSubmit}
                // onError={state.onError}
                // onChange={async (props): Promise<void> => {
                // if (state.shouldSubmitFlag === true) {
                //     await state.onSubmit(props);
                //     state.setShouldSubmitFlag(false);
                //     await state.serviceSettings.refresh();
                // }
                //}}
                templates={{
                    ButtonTemplates: { AddButton, MoveDownButton, MoveUpButton, RemoveButton, SubmitButton },
                    TitleFieldTemplate,
                    DescriptionFieldTemplate,
                    ObjectFieldTemplate: CustomObjectFieldTemplate,
                    ErrorListTemplate: CustomErrorList,
                    FieldTemplate: CustomFieldTemplate,
                    ArrayFieldTemplate: CustomArrayFieldTemplate,
                }}
            />
        </FormContainer>
    );
});
